const resetComponentConfig = {
  cropSettings: null,
  imageWidth: null,
  imageHeight: null,
  imageId: null,
  imageName: null,
  fileName: null,
  editWithCropper: null,
  externalSrc: null,
};

export const updateImageByExternal = (originalComponentConfig, externalSrc) => ({
  ...originalComponentConfig,
  ...resetComponentConfig,
  externalSrc,
});

export const updateImageByMeta = (originalComponentConfig, imageMeta, fileObj, externalSrc) => {
  const {
    IdString: imageId,
    Width: imageWidth,
    Height: imageHeight,
    CropSettings: cropSettings,
    FileName: metaFileName,
  } = imageMeta;

  return {
    ...originalComponentConfig,
    ...resetComponentConfig,
    imageId,
    imageWidth,
    imageHeight,
    cropSettings,
    fileName: metaFileName || (fileObj ? fileObj.name : null),
    externalSrc,
  };
};

export const updateImageByName = (originalComponentConfig, imageName) => ({
  ...originalComponentConfig,
  ...resetComponentConfig,
  imageName,
});
